import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 439.31 106.42"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "data-name": "Layer 2" }, [
  /*#__PURE__*/_createElementVNode("g", { "data-name": "Layer 1" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M437.31 19.23V19a17 17 0 0 0-17-17H202.64a17 17 0 0 0-17 17v.24a17 17 0 0 0 17 17h53.47a17 17 0 0 1 17 17 17 17 0 0 1-17 17H19a17 17 0 0 0-17 17v.24a17 17 0 0 0 17 17h401.32a17 17 0 0 0 17-17v-.24a17 17 0 0 0-17-17h-8.57a17 17 0 0 1-17-17 17 17 0 0 1 17-17h8.57a17 17 0 0 0 16.99-17.01Z",
      "data-name": "Clouds",
      style: {"fill":"#fff7f3","stroke":"#2d2d34","stroke-miterlimit":"10","stroke-width":"2px"}
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }